(ns app.api-webhook.validation
  "Shared constants and lightweight validation for API webhooks."
  (:require [clojure.string :as str]))

(def max-endpoint-count 5)

(def status-changed-event-type
  :webhook.event/instagram-story-post-status-changed)

(def status-changed-event-name
  "instagram_story_post.status_changed")

(def social-post-status-changed-event-type
  :webhook.event/social-post-status-changed)

(def social-post-status-changed-event-name
  "social_post.status_changed")

(def event-names
  {status-changed-event-type status-changed-event-name
   social-post-status-changed-event-type social-post-status-changed-event-name})

(def event-types
  "The event types a new endpoint subscribes to."
  [status-changed-event-type
   social-post-status-changed-event-type])

(def delivery-status-pending
  :webhook-delivery.status/pending)

(def delivery-status-retrying
  :webhook-delivery.status/retrying)

(def delivery-status-delivered
  :webhook-delivery.status/delivered)

(def delivery-status-failed
  :webhook-delivery.status/failed)

(def delivery-status-skipped
  :webhook-delivery.status/skipped)

(defn valid-webhook-url-format?
  [url]
  (and (string? url)
       (str/starts-with? (str/lower-case (str/trim url))
                         "https://")))

(defn url-error-message
  [url]
  (cond
    (str/blank? url)
    "Please enter a webhook URL."

    (not (valid-webhook-url-format? url))
    "Webhook URLs must start with https://."

    :else
    nil))
